const hasRate = (data, direction, rate) => data?.some((record) => record[`${direction}_rate_category`] === rate);

export default hasRate;
